<template>
  <b-card no-body class="recommendation-color w-100">
    <b-card-body class="d-flex flex-column p-0">
      <div class="recommendation-align">
        <img
          src="@/assets/images/portfolio/PrimeRecommendations.svg"
          alt="1"
          class="recommendation-img"
        />
        <h4 class="card-title recommendation-title">Prime Recommendations</h4>
      </div>
      <div class="g-asaloc-tab2-nav">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="g-asaloc-tab2-nav-item"
          :class="{ active: activeTab === index }"
          @click="handleTabClick(index)"
        >
          <div class="g-asaloc-tab2-nav-title">
            {{ tab.title }}
          </div>
        </div>
      </div>
      <div class="tab-content-wrapper blur_section" ref="tabContentWrapper">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :id="`tab${index}`"
          class="tab-content"
          :class="{ active: activeTab === index }"
        >
          <div
            class="activity-feed mb-0"
            :class="{
              'recommendation-simplebar-prp':
                isPortfolioEmpty &&
                (planType === 'Prime-registered' || planType === 'Active' || planType === 'Prime-registered' || planType === 'Active' || planType === 'Prime Trial' ||planType === 'Prime Trial' ||
                    planType === 'Trial Expired' ||
                    planType === 'Subscription expired'),
              'recommendation-simplebar':
                !isPortfolioEmpty,
            }"
            data-simplebar
          >
            <div
              v-for="item in tab.items"
              :key="item.id"
              @click="openStockLink(item, tab.title)"
              class="mt-3"
              :class="['content-div', { 'stocks-cursor': isStocksTabActive }]"
            >
              <div v-if="item.new_flag === '1'">
                <span class="new-tag">NEW</span>
              </div>
              <div v-if="index != 0">
                <p
                  class="item-title"
                  :title="activeTab === 1 ? item?.name : ''"
                  v-b-tooltip.hover="activeTab === 1 ? 'item.name' : null"
                >
                  {{ index === 1 ? truncateText(item.name, 37) : item.name }}
                </p>
                <span class="badge earning-compounder">
                  <img
                    :src="require('@/assets/images/portfolio/logo.svg')"
                    alt="image"
                    class="stock-logo"
                    style="width: 12px"
                  />&nbsp;{{ item.fund_name }}</span
                >
              </div>
              <div class="item-info d-flex align-items-center" v-else>
                <p
                  class="item-name d-flex justify-content-between align-items-center"
                >
                  {{ item.name }}
                </p>
                <span
                  v-if="item.best_buy === '1'"
                  class="ms-auto best-buy rounded p-1"
                  >★ Best Buy</span
                >
              </div>
              <div>
                <div v-if="tab.title === 'Stocks'" class="returns-stock">
                  <div class="header-row">
                    <span class="text-start">CMP</span>
                    <span class="text-center">Mcap(Cr)</span>
                    <span class="text-end">Returns</span>
                  </div>
                  <div class="value-row">
                    <span class="text-start">{{ item.current_price }}</span>
                    <span class="text-center">{{ item.market_price }}</span>
                    <span
                      :class="{
                        positive: parseFloat(item.return) > 0,
                        negative: parseFloat(item.return) < 0,
                      }"
                      class="text-end"
                      >{{ item.return }}</span
                    >
                  </div>
                </div>
                <div v-else class="returns">
                  <div class="header-row">
                    <span class="text-start">1Y Return</span>
                    <span class="text-center">3Y Return</span>
                    <span class="text-end">5Y Return</span>
                  </div>
                  <div class="value-row">
                    <span
                      :class="{
                        positive: parseFloat(item.one_return) > 0,
                        negative: parseFloat(item.one_return) < 0,
                      }"
                      class="text-start"
                      >{{ item.one_return }}</span
                    >
                    <span
                      :class="{
                        positive: parseFloat(item.three_return) > 0,
                        negative: parseFloat(item.three_return) < 0,
                      }"
                      class="text-center"
                      >{{ item.three_return }}</span
                    >
                    <span
                      :class="{
                        positive: parseFloat(item.five_return) > 0,
                        negative: parseFloat(item.five_return) < 0,
                      }"
                      class="text-end"
                      >{{ item.five_return }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <a
              v-if="viewAllText()"
              :href="viewAllText().url"
              target="_blank"
              rel="noopener noreferrer"
              class="view-funds-link d-flex justify-content-center"
              >{{ viewAllText().text }}</a
            >
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
  <SubscriptionExpiredModal
    ref="stocksExpiredModal"
    message="This feature is available to Prime Growth subscribers only. Upgrade your plan to access"
    heading="Upgrade to see"
    buttonText="Upgrade now"
  />
  <SubscriptionExpiredModal ref="expiredModal" />
</template>

<script>
import SimpleBar from "simplebar";
import SubscriptionExpiredModal from "./SubcriptionExpiredModal";
import { mapGetters } from "vuex";

export default {
  name: "SocialService",
  components: {
    SubscriptionExpiredModal,
  },
  data() {
    return {
      activeTab: 1,
      jsonData: null,
      tabs: [
        {
          title: "Stocks",
          items: [],
        },
        {
          title: "Mutual Funds",
          items: [],
        },
        {
          title: "ETF",
          items: [],
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "primeRecommendations",
      "subscriptionType",
      "myPortfolio",
      "planType",
    ]),
    currentTabItems() {
      return this.tabs[this.activeTab].items;
    },
    isPortfolioEmpty() {
      return Object.keys(this.myPortfolio).length === 0;
    },
    isStocksTabActive() {
      return this.activeTab === 0;
    },
  },
  methods: {
    handleTabClick(index) {
      this.selectTab(index);
    },
    newFlagCount(items) {
      if (!items || !Array.isArray(items)) {
        return 0;
      }
      const count = items.filter((item) => item.new_flag === "1").length;
      return count;
    },
    selectTab(index) {
      if (this.subscriptionType === "sub-expired" && index !== 0) {
        this.$refs.expiredModal.showModal();
      } else {
        this.activeTab = index;
      }
    },
    truncateText(text, maxLength) {
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    },
    viewAllLink() {
      if (
        this.tabs.length === 0 ||
        this.activeTab < 0 ||
        this.activeTab >= this.tabs.length
      ) {
        return null;
      }
      const tabTitle = this.tabs[this.activeTab].title;
      const baseURL = process.env.VUE_APP_BASE_URL;
      if (tabTitle === "Mutual Funds") {
        return { text: "View all Prime Funds", url: `${baseURL}/prime-funds/` };
      } else if (tabTitle === "ETF") {
        return { text: "View all Prime ETFs", url: `${baseURL}/prime-etfs/` };
      } else {
        return {
          text: "View all Prime Stocks",
          url: `${baseURL}/prime-stocks/`,
        };
      }
    },
    viewAllText() {
      const link = this.viewAllLink();
      return link ? link : { text: "Default Text" };
    },
    openStockLink(item, tabTitle) {
      if (tabTitle === "Stocks") {
        const baseURL = process.env.VUE_APP_BASE_URL;
        const code = item.co_code;
        const url = `${baseURL}/prime-stocks/stock/${code}`;
        window.open(url, "_blank");
      }
    },
    loadRecommendations(data) {
      try {
        if (Object.keys(data).length > 0) {
          this.tabs[0].items = data.stockrec.map((stock, index) => ({
            id: index + 1,
            name: stock.stock_name,
            image: `${process.env.VUE_APP_BASE_URL}${stock.companyLogo}`,
            fund_name: stock.stock_type,
            current_price: `${stock.cur_price >= 0 ? "₹" : ""} ${
              stock.cur_price
            }`,
            market_price: `₹ ${stock.market_cap}`,
            return:
              stock.stock_return === "0" ? "NA" : `${stock.stock_return}(%)`,
            best_buy: `${stock.bestBuy}`,
            new_flag: `${stock.newFlag}`,
            co_code: `${stock.ccode}`,
          }));

          this.tabs[1].items = data.mf_rec.map((mfItem, index) => ({
            id: index + 1,
            name: mfItem.fundName,
            fund_name: mfItem.primeFundCategory,
            one_return:
              mfItem.oneYearReturnPercentage !== null &&
              mfItem.oneYearReturnPercentage !== undefined
                ? mfItem.oneYearReturnPercentage === "0"
                  ? "NA"
                  : `${mfItem.oneYearReturnPercentage > 0 ? "+" : ""}${
                      mfItem.oneYearReturnPercentage
                    }(%)`
                : "0",
            three_return:
              mfItem.threeYearReturnPercentage !== null &&
              mfItem.threeYearReturnPercentage !== undefined
                ? mfItem.threeYearReturnPercentage === "0"
                  ? "NA"
                  : `${mfItem.threeYearReturnPercentage > 0 ? "+" : ""}${
                      mfItem.threeYearReturnPercentage
                    }(%)`
                : "0",
            five_return:
              mfItem.fiveYearReturnPercentage !== null &&
              mfItem.fiveYearReturnPercentage !== undefined
                ? mfItem.fiveYearReturnPercentage === "0"
                  ? "NA"
                  : `${mfItem.fiveYearReturnPercentage > 0 ? "+" : ""}${
                      mfItem.fiveYearReturnPercentage
                    }(%)`
                : "0",
            new_flag: `${mfItem.newFlag}`,
            best_buy: `${mfItem.bestBuy}`,
          }));

          this.tabs[2].items = data.etfrecm.map((etfrecms, index) => ({
            id: index + 1,
            name: `${etfrecms.fundName}${
              etfrecms.fundRating ? ` ★ ${etfrecms.fundRating}` : ""
            }`,
            fund_name: etfrecms.primeFundCategory,
            one_return:
              etfrecms.oneYearReturnPercentage !== null &&
              etfrecms.oneYearReturnPercentage !== undefined
                ? etfrecms.oneYearReturnPercentage === "0"
                  ? "NA"
                  : `${etfrecms.oneYearReturnPercentage > 0 ? "+" : ""}${
                      etfrecms.oneYearReturnPercentage
                    }(%)`
                : "0",
            three_return:
              etfrecms.threeYearReturnPercentage !== null &&
              etfrecms.threeYearReturnPercentage !== undefined
                ? etfrecms.threeYearReturnPercentage === "0"
                  ? "NA"
                  : `${etfrecms.threeYearReturnPercentage > 0 ? "+" : ""}${
                      etfrecms.threeYearReturnPercentage
                    }(%)`
                : "0",
            five_return:
              etfrecms.fiveYearReturnPercentage !== null &&
              etfrecms.fiveYearReturnPercentage !== undefined
                ? etfrecms.fiveYearReturnPercentage === "0"
                  ? "NA"
                  : `${etfrecms.fiveYearReturnPercentage > 0 ? "+" : ""}${
                      etfrecms.fiveYearReturnPercentage
                    }(%)`
                : "0",
            new_flag: `${etfrecms.newFlag}`,
            best_buy: `${etfrecms.bestBuy}`,
          }));
          this.activeTab = this.planType === "Prime Essentials" ? 1 : 0;
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    },
    getMarketPriceClass(oneDayChangePercentage) {
      return parseFloat(oneDayChangePercentage) >= 0 ? "positive" : "negative";
    },
  },
  watch: {
    primeRecommendations: {
      handler(newValue) {
        this.loadRecommendations(newValue);
      },
      immediate: true,
    },
  },
  mounted() {
    new SimpleBar(
      this.$refs.tabContentWrapper.querySelector("[data-simplebar]")
    );
  },
};
</script>

<style scoped>
.recommendation-color {
  background: linear-gradient(180deg, #ffffff 0%, #e3f9ff 100%);
  border-radius: 5px;
}

.recommendation-align {
  position: relative;
  right: 5px;
  padding: 10px;
}

.recommendation-img {
  position: relative;
  top: 5px;
  left: 6px;
  height: 35px;
  width: 30px;
}

.recommendation-title {
  position: absolute;
  left: 54px;
  top: 22px;
}

.recommendation-simplebar-prp {
  height: 642px;
  margin-top: -10px;
  padding-left: 1rem;
  padding-right: 1rem;
}

.recommendation-simplebar {
  max-height: 255px;
  margin-top: -10px;
  padding-left: 1rem;
  padding-right: 1rem;
}

.header-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 400;
}

.value-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 100;
}

.header-row span,
.value-row span {
  flex: 1;
  text-align: center;
}

.header-row span.text-start,
.value-row span.text-start {
  text-align: left;
}

.header-row span.text-end,
.value-row span.text-end {
  text-align: right;
}

.g-asaloc-tab2-nav {
  display: flex;
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
  padding-bottom: 7px;
}

.g-asaloc-tab2-nav-item {
  flex: 1;
  cursor: pointer;
  text-align: center;
  padding: 5px 0;
  position: relative;
  border: 1px solid #00a3d9;
  border-radius: 0;
}

.g-asaloc-tab2-nav-item:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.g-asaloc-tab2-nav-item:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.g-asaloc-tab2-nav-item.active {
  background-color: #00a3d9;
  color: white;
  border-bottom: none;
}

.g-asaloc-tab2-nav-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.count-badge {
  background-color: #dd2e44;
  color: white;
  padding: 0px 3px;
  border-radius: 4px;
  margin-left: 5px;
  font-size: 10px;
}

.tab-content-wrapper {
  flex-grow: 1;
  padding: 10px;
  overflow: hidden;
}

.tab-content {
  display: none;
}

.best-buy {
  background-color: #f2f231;
  font-size: 9px;
}

.tab-content.active {
  display: block;
}

.content-div:hover {
  box-shadow: 0px 4px 4px rgba(0.1, 0.1, 0.1, 0.5);
}

.stocks-cursor:hover {
  box-shadow: 0px 4px 4px rgba(0.1, 0.1, 0.1, 0.5);
  cursor: pointer;
}

.item-name {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
}

.fund-name {
  background-color: rgb(119, 104, 174);
  color: white;
  border-radius: 6px;
  padding: 1px 4px;
  font-size: 14px;
  margin-top: 5px;
  text-align: center;
}

.item-title {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  margin-bottom: 0px;
}

.earning-compounder {
  background: white;
  color: black;
  font-size: 12px;
}

.buy {
  background: #71c017;
  position: absolute;
  top: 15px;
  left: 347px;
  font-size: 9px;
}

.returns {
  padding-top: 8px;
  border-radius: 8px;
  padding-right: 4px;
  font-size: 14px;
}

.returns-stock {
  border-radius: 8px;
  padding-right: 4px;
  font-size: 14px;
}

.view-funds-link {
  color: #00a3d9;
}

.content-div {
  position: relative;
  width: 100%;
  background: rgba(0, 163, 217, 0.12);
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 18px;
  overflow: hidden;
  margin-top: 9px;
}

.new-tag {
  position: absolute;
  top: 50px;
  left: -52px;
  background-color: #dd2e44;
  color: white;
  padding: 11px 60px 0px 60px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  transform: rotate(-45deg);
  transform-origin: 0 0;
  z-index: 10;
}

@media (max-width: 768px) {
  .g-asaloc-tab2-nav-item {
    padding: 5px 0;
    font-size: 12px;
  }

  .returns-header,
  .returns-values {
    font-size: 9px;
  }
}

.positive {
  color: green;
}

.negative {
  color: red;
}

.stock-read {
  padding: 2px;
  margin-left: 107px;
  margin-top: -3px;
  gap: 10px;
  background: rgba(145, 141, 153, 0.5);
  border-radius: 10px;
}
</style>
